module.exports = __webpack_public_path__ + "media/images/front/icons/profile_edit-9f0e599859197d3e1f83a407de788106.png";